export const ALPHANUMERIC_REGEX = /^[a-zA-Z0-9]*$/

export const validateUmr = (value: string): boolean => {
  return ALPHANUMERIC_REGEX.test(value)
}
